import { useEffect, useMemo, useState } from "react";
import AdminLayout from "../../components/admin/AdminLayout";
import { adminApi } from "../../lib/admin-api";
import ReactMarkdown from "react-markdown";
import { Download, BookOpen } from "lucide-react";

export default function AdminManual() {
    const [md, setMd] = useState("");

    useEffect(() => {
        let alive = true;
        adminApi.get("/manual").then((r) => { if (alive) setMd(r.data?.markdown || ""); }).catch(console.error);
        return () => { alive = false; };
    }, []);

    const toc = useMemo(() => {
        return md.split("\n").filter((l) => l.startsWith("## ")).map((l) => {
            const t = l.slice(3).trim();
            const slug = t.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\w]+/g, "-").replace(/^-|-$/g, "");
            return { text: t, slug };
        });
    }, [md]);

    const downloadPdf = async () => {
        const token = localStorage.getItem("admin_token");
        const url = `${process.env.REACT_APP_BACKEND_URL}/api/admin/manual/pdf`;
        try {
            const r = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
            if (!r.ok) throw new Error("PDF generation failed");
            const blob = await r.blob();
            const a = document.createElement("a");
            a.href = window.URL.createObjectURL(blob);
            a.download = "manual_eclipse.pdf";
            a.click();
            a.remove();
        } catch (e) {
            console.error(e);
            alert("No se pudo generar el PDF. Verifica que WeasyPrint esté instalado.");
        }
    };

    return (
        <AdminLayout
            title="Manual del CRM"
            subtitle="Guía práctica para el equipo Eclipse"
            testid="admin-manual-page"
            actions={
                <button onClick={downloadPdf} className="h-9 px-3 border border-neutral-200 rounded-md text-sm flex items-center gap-2 bg-white hover:bg-neutral-50" data-testid="manual-pdf-btn">
                    <Download className="w-4 h-4" /> Descargar PDF
                </button>
            }
        >
            <div className="grid grid-cols-1 lg:grid-cols-[220px_1fr] gap-6">
                <aside className="hidden lg:block">
                    <div className="sticky top-20 bg-white border border-neutral-200 rounded-md p-4">
                        <div className="text-[10px] uppercase tracking-wider text-neutral-500 font-semibold mb-3 flex items-center gap-1.5"><BookOpen className="w-3 h-3" /> Contenido</div>
                        <nav className="text-xs space-y-1.5" data-testid="manual-toc">
                            {toc.map((t) => (
                                <a key={t.slug} href={`#${t.slug}`} className="block text-neutral-600 hover:text-eclipse-cta">{t.text}</a>
                            ))}
                        </nav>
                    </div>
                </aside>
                <article className="bg-white border border-neutral-200 rounded-md p-6 lg:p-10">
                    <div className="prose prose-sm sm:prose-base max-w-none prose-headings:font-display prose-headings:tracking-tight prose-h1:text-3xl prose-h1:border-b prose-h1:border-eclipse-cta prose-h1:pb-2 prose-h2:text-xl prose-h2:mt-10 prose-h2:text-eclipse-primary prose-a:text-eclipse-cta prose-strong:text-eclipse-primary">
                        <ReactMarkdown
                            components={{
                                h2: ({ children }) => {
                                    const text = String(children);
                                    const slug = text.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^\w]+/g, "-").replace(/^-|-$/g, "");
                                    return <h2 id={slug}>{children}</h2>;
                                },
                            }}
                        >
                            {md}
                        </ReactMarkdown>
                    </div>
                </article>
            </div>
        </AdminLayout>
    );
}
